"use strict";
exports.__esModule = true;
exports.isInternalEntity = void 0;
var glossary_1 = require("../glossary");
/**
 * Determines if the given object is an internal entity.
 */
function isInternalEntity(value) {
    return (glossary_1.InternalEntityProperty.type in value &&
        glossary_1.InternalEntityProperty.primaryKey in value);
}
exports.isInternalEntity = isInternalEntity;
